import eight from '../assets/svg/projects/eight.svg'
import seven from '../assets/svg/projects/seven.svg'
import six from '../assets/svg/projects/six.svg'
import four from '../assets/svg/projects/four.svg'



export const projectsData= [
    {
        id: 1,
        projectName: 'E-Commerce Platform',
        projectDesc: 'Built a scalable and feature-rich e-commerce platform with advanced product search, user authentication, and payment processing.',
        tags: ['React', 'Node.js', 'Express', 'MongoDB', 'Stripe'],
        code: '#',
        demo: '#',
        image: six,
    },
    {
        id: 2,
        projectName: 'Smart Home Automation',
        projectDesc: 'Developed an innovative smart home automation system allowing users to control their home devices remotely via a user-friendly mobile app.',
        tags: ['React Native', 'Node.js', 'Firebase', 'IoT'],
        code: '#',
        demo: '#',
        image: seven,
    },
    {
        id: 3,
        projectName: 'Smart Chatbot Platform',
        projectDesc: 'Developed a smart chatbot platform using natural language processing (NLP) and machine learning algorithms. The chatbot is capable of understanding user queries and providing intelligent responses.',
        tags: ['React', 'Node.js', 'Express', 'MongoDB', 'TensorFlow', 'NLP'],
        code: '#',
        demo: '#',
        image: four,
    },
];



